import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { FriendlyDatePipe } from './pipes/friendly-date.pipe';

@Component({
  standalone: true,
  imports: [FriendlyDatePipe],
  selector: 'place-of-weather',
  template: `
    @if (open) {
      <div class="open-place" (click)="closeWeather($event)">
        <div class="container">
          <div class="weather-text"><span class="weather-date">{{ date | friendlyDate }}.</span>
            @if (showConsultLink()) {
              <a class="consult-link" href="{{ detailURL }}">open</a>
            }
            <span class="weather-text-span" [innerHTML]="bodyInBrs"></span>
          </div>
        </div>
      </div>
    } @else {
      <div class="place" [style.left]="left+'%'" [style.top]="top+'%'">
        <a class="place-name" (click)="openWeather()">{{ dotLabel }}</a>
        <div class="place-shadow"></div>
      </div>
    }
  `,
  styleUrl: './place-of-weather.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class PlaceOfWeather {

  @Input() id = 0;
  @Input() open = false;
  @Input() left = 50;
  @Input() top = 50;
  @Input() body = '';
  @Input() bodyInBrs = '';
  @Input() date = '';
  @Input() dotLabel = '';
  @Input() detailURL = '';
  // @Output() bumpToTop = new EventEmitter<number>();

  // @Input() order = 0;
  // @Output() orderChange = new EventEmitter<number>();
  // @Input() highestOrder = 0;
  // @Output() highestOrderChange = new EventEmitter<number>();

  ngOnInit(): void {
    this.setPosition();
  }

  openWeather() {
    this.open = true;
    // this.bumpToTop.emit(this.id);
  };

  setPosition() {
    this.left = Math.floor(Math.random() * 80),
    this.top = Math.floor(Math.random() * 40)
  };

  showConsultLink() {
    return this.body.length > 500;
  };

  closeWeather(event: MouseEvent) {
    if (event.target instanceof HTMLAnchorElement) {
      return;
    }

    const selection = window.getSelection()?.toString();
    if (selection && selection.length > 0) {
      return;
    }

    this.setPosition();
    this.open = false;
  };

}
